import React from "react";
import { BadgeCheck } from "lucide-react";

// Blue "Admin Verified" checkmark for force-approved / admin-vetted providers.
export function AdminVerifiedBadge({ size = "sm", showLabel = true, className = "" }) {
  const px = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <span
      data-testid="admin-verified-badge"
      title="Admin Verified provider"
      className={`inline-flex items-center gap-1 text-cyan-300 ${className}`}
    >
      <BadgeCheck className={`${px} text-cyan-400 fill-cyan-400/20`} />
      {showLabel && <span className="text-[11px] font-semibold uppercase tracking-wide">Admin Verified</span>}
    </span>
  );
}

export default AdminVerifiedBadge;
